import type { CurrencyFormatSettings } from '../../../../../types/Configuration';

const forceAmountWithDigits = (amount: number, currencyConfig: CurrencyFormatSettings | undefined) => {
  if (!currencyConfig) {
    return amount.toString();
  }

  const { fractionDigits } = currencyConfig;

  return amount.toFixed(fractionDigits);
};

export const forceAmountWithDigitsWhenFloat = (amount: number, currencyConfig: CurrencyFormatSettings | undefined) => {
  if (Math.floor(amount) === amount) return amount.toString();

  return forceAmountWithDigits(amount, currencyConfig);
};

export default forceAmountWithDigits;
